/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* global $ */
import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalAltaPendiente.css';

class ModalAltaPendiente extends React.Component {
  static formatearFecha(fecha) {
    const anio = fecha.substr(0, 4);
    const mes = fecha.substr(4, 2);
    const dia = fecha.substr(6, 2);

    return `${dia}/${mes}/${anio}`;
  }
  componentDidMount() {
    $('#ModalAltaPendiente').modal({ backdrop: 'static', keyboard: false });
    $('.close').hide();
  }

  render() {
    return (
      <div
        className="modal fade modal-admin in"
        id="ModalAltaPendiente"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" style={{ fontSize: '20px' }}>
                <b>Alta pendiente</b>
              </h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 text-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className={`${s.icono}`}
                    width="68px"
                    height="68px"
                  >
                    <path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm42-104c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42zm-81.37-211.401l6.8 136c.319 6.387 5.591 11.401 11.985 11.401h41.17c6.394 0 11.666-5.014 11.985-11.401l6.8-136c.343-6.854-5.122-12.599-11.985-12.599h-54.77c-6.863 0-12.328 5.745-11.985 12.599z" />
                  </svg>
                </div>
              </div>
              <br />
              <div className="row row-text">
                <div className="col-md-12 text-center">
                  <p>
                    {`Tu cuenta será activada a partir del ${ModalAltaPendiente.formatearFecha(
                      this.props.fechaAlta,
                    )} `}
                    <br />
                    Ante cualquier duda por favor comunicate al 0810-444-7700.
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-12 text-center">
                <button
                  data-dismiss="modal"
                  className={`${s.boton_rojo} btn btn-danger text-center`}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, null)(withStyles(s)(ModalAltaPendiente));



// WEBPACK FOOTER //
// ./src/components/Login/ModalAltaPendiente/ModalAltaPendiente.js